module.exports = __webpack_public_path__ + "static/img/caonima.1cb4f69.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/common/emoji/caonima.gif
// module id = UCMz
// module chunks = 2